import {create} from 'zustand';
import {devtools} from 'zustand/middleware';
import {inventoryCookies, inventoryFavourites} from '../Cookies';
import FavouritesService from '../services/favourites-service';

interface FavouritesInterface {
  id?: string;
  vins?: string[];
}

interface UseFavouritesInterface {
  favourites: FavouritesInterface;
  updateFavourites: (baseUrl: string, id: string) => void;
}

const fetchSavedFavourites = () => {
  // console.log(inventoryCookies.get(inventoryFavourites));
  return inventoryCookies.get(inventoryFavourites) || [];
}

export const updateSavedFavourites = (
  ulid?: string | null,
  vins?: string[] | null,
) => {

  const expireDate = new Date();
  expireDate.setDate(expireDate.getDate() + 30);
  const cookieValues = {id: ulid, vins};
  inventoryCookies.set(inventoryFavourites, cookieValues, {
    expires: expireDate,
    path: '/',
  });

};

export const useFavouritesStore = create<UseFavouritesInterface>()(
  devtools((set, get) => ({
    favourites: fetchSavedFavourites(),
    updateFavourites: async (baseUrl, id) => {
      let ulid = get().favourites?.id;

      const favService = new FavouritesService(baseUrl, ulid);

      let vins: string[] = (
        get().favourites?.vins?.length ? get().favourites.vins : []
      ) as string[];
      const index = vins?.indexOf(id);

      if (index !== undefined && index > -1) {
        vins?.splice(index, 1);
      } else {
        vins?.push(id);
      }

      const ulidResponse = await favService.request(vins);

      if (ulid == undefined) {
        ulid = ulidResponse.meta?.id.ulid;
      }

      updateSavedFavourites(ulid ? ulid : null, vins.length ? vins : null);

      set(() => ({
        favourites: {
          id: ulid,
          vins,
        },
      }));
    },
  })),
);
